export interface SportsMenuProps {}
export interface StyledSportsMenuItemProps {
  $active?: boolean
}

export enum ESportsMenuTabTypes {
  LINE = 'line',
  LIVE = 'live'
}
